/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ls_reverse = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse`)
};

const es_ls_reverse = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invertir`)
};

const de_ls_reverse = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umkehren`)
};

const nl_ls_reverse = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omgekeerd`)
};

const fr_ls_reverse = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverser`)
};

const it_ls_reverse = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverti`)
};

const pt_br2_ls_reverse = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverter`)
};

const pt_ls_reverse = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverter`)
};

const ja_ls_reverse = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逆順`)
};

const zh_ls_reverse = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反向排序`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ls_reverse = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ls_reverse(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ls_reverse", locale)
	if (locale === "en") return en_ls_reverse(inputs)
	if (locale === "es") return es_ls_reverse(inputs)
	if (locale === "de") return de_ls_reverse(inputs)
	if (locale === "nl") return nl_ls_reverse(inputs)
	if (locale === "fr") return fr_ls_reverse(inputs)
	if (locale === "it") return it_ls_reverse(inputs)
	if (locale === "pt-BR") return pt_br2_ls_reverse(inputs)
	if (locale === "pt") return pt_ls_reverse(inputs)
	if (locale === "ja") return ja_ls_reverse(inputs)
	return zh_ls_reverse(inputs)
};